import React, { useState, useMemo } from 'react';
import { Table, Button } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import ModalRequestHelp from './ModelRequestHelp';

const getColumnsTranslated = (t, handleRequestHelp) => [
  {
    title: t('transactionId'),
    dataIndex: 'id',
    key: 'id',
    width: '120px',
  },
  {
    title: t('phoneNumber'),
    dataIndex: 'client_phone',
    key: 'client_phone',
  },
  {
    title: t('customerName'),
    dataIndex: 'client_full_name',
    key: 'client_full_name',
    sorter: true,
  },
  {
    title: t('depositAmount'),
    dataIndex: 'amount',
    key: 'amount',
    sorter: true,
    render: (value) => value && value.toFixed && value.toFixed(2),
  },
  {
    title: t('depositTimestamp'),
    dataIndex: 'created_at',
    key: 'created_at',
    width: '260px',
    render: (date) => moment(date).format('LLL'),
  },
  {
    title: t('help'),
    width: '130px',
    render: (record) => (
      <Button link onClick={() => handleRequestHelp(record)}>
        {t('requestHelp')}
      </Button>
    ),
  },
];

const TableTransactions = (props) => {
  const { dataSource, loading, onChange, pagination } = props;
  const [selectedRecord, setSelectedRecord] = useState();
  const { t } = useTranslation();

  const columns = useMemo(() => getColumnsTranslated(t, setSelectedRecord), [
    t,
  ]);

  const onCancelRequestHelp = () => {
    setSelectedRecord(undefined);
  };

  return (
    <>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        onChange={onChange}
        pagination={pagination}
        scroll={{ x: 1300, y: 'calc(100vh - 320px)' }}
      />
      {!!selectedRecord && (
        <ModalRequestHelp
          closeModal={onCancelRequestHelp}
          transaction={selectedRecord}
        />
      )}
    </>
  );
};

export default TableTransactions;
